import React, { useEffect, useState } from 'react';
import Layout from '../../Components/Layout';
import { useNavigate } from 'react-router-dom';
import { Icon } from "@iconify/react";
import axios from 'axios';
import toast from 'react-hot-toast';

const InvoiceList = () => {

    const navigate = useNavigate();

    const [invoiceList, setInvoiceList] = useState([]);

    const [loading, setLoading] = useState(false);

    const [searchInvoiceNo, setSearchInvoiceNo] = useState('');

    // ================= FETCH INVOICES =================
    const fetchInvoices = async () => {

        try {

            setLoading(true);

            const token = localStorage.getItem("token");

            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/invoices`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log("Invoice List => ", response.data);

            // IMPORTANT
            setInvoiceList(response.data.content);

        } catch (error) {

            console.error("Fetch Invoice Error => ", error);

            toast.error("Failed To Fetch Invoices");

        } finally {

            setLoading(false);
        }
    };

    // ================= DELETE INVOICE =================
    const handleDelete = async (id) => {

        const confirmDelete = window.confirm(
            'Are you sure you want to delete this invoice?'
        );

        if (!confirmDelete) return;

        try {

            const token = localStorage.getItem("token");

            await axios.delete(
                `${process.env.REACT_APP_BACKEND_URL}/invoices/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );


            toast.success("Invoice Deleted Successfully")

            fetchInvoices();

        } catch (error) {

            console.error("Delete Invoice Error => ", error);
            toast.error("Failed To Delete Invoice")

        }
    };

    // ================= USE EFFECT =================
    useEffect(() => {

        fetchInvoices();

    }, []);

    // ================= SEARCH FILTER =================
    const filteredInvoices = invoiceList.filter((invoice) =>
        invoice?.invoiceNo
            ?.toLowerCase()
            .includes(searchInvoiceNo.toLowerCase())
    );

    return (

        <Layout>

            <div className="backgound-main-content p-4">

                <div className="container-fluid">

                    {/* Header */}
                    <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">

                        <h3 className="mb-0 fw-bold">
                            Invoice List
                        </h3>

                        <button
                            className="btn btn-primary"
                            onClick={() => navigate('/create-invoice')}
                        >
                            Create Invoice
                        </button>

                    </div>

                    {/* Search */}
                    <div className="row mb-4">

                        <div className="search-bar">

                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by Invoice No"
                                value={searchInvoiceNo}
                                onChange={(e) =>
                                    setSearchInvoiceNo(e.target.value)
                                }
                            />

                            <Icon
                                icon="iconamoon:search"
                                width="20"
                                height="20"
                                color="rgba(0, 175, 239, 1)"
                            />

                        </div>

                    </div>

                    {/* Table */}
                    <div className="table-responsive">

                        <table className="table table-bordered table-hover align-middle">

                            <thead className="table-light">

                                <tr>
                                    <th>Sr No</th>
                                    <th>Invoice No</th>
                                    <th>Order Id</th>
                                    <th>Date</th>
                                    <th>Total Amount</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>

                            </thead>

                            <tbody>

                                {loading ? (

                                    <tr>
                                        <td
                                            colSpan="7"
                                            className="text-center"
                                        >
                                            Loading...
                                        </td>
                                    </tr>

                                ) : filteredInvoices.length > 0 ? (

                                    filteredInvoices.map((invoice, index) => (

                                        <tr key={invoice.id}>

                                            <td>{index + 1}</td>

                                            <td>{invoice.invoiceNo}</td>

                                            <td>{invoice.orderId}</td>

                                            <td>{invoice.date}</td>

                                            <td>
                                                ₹ {invoice.total}
                                            </td>

                                            <td>

                                                <span
                                                    className={`badge ${invoice.paymentStatus === 'PAID'
                                                        ? 'bg-success'
                                                        : 'bg-warning text-dark'
                                                        }`}
                                                >
                                                    {invoice.paymentStatus}
                                                </span>

                                            </td>

                                            <td>

                                                <div className="d-flex gap-2 flex-wrap">

                                                    {/* View */}
                                                    <Icon
                                                        icon="hugeicons:view"
                                                        style={{
                                                            color: "#00AFEF",
                                                            fontSize: "18px",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                            navigate(
                                                                `/view-invoice/${invoice.id}`,
                                                                {
                                                                    state: {
                                                                        invoice,
                                                                    },
                                                                }
                                                            )
                                                        }
                                                    />

                                                    {/* Edit */}
                                                    <Icon
                                                        icon="mdi:edit"
                                                        style={{
                                                            color: "#00AFEF",
                                                            fontSize: "18px",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                            navigate('/create-invoice', {
                                                                state: {
                                                                    invoiceId: invoice.id,
                                                                    isEdit: true,
                                                                },
                                                            })
                                                        }
                                                    />

                                                    {/* Delete
                                                    <Icon
                                                        icon="material-symbols:delete-outline"
                                                        width="20"
                                                        className="cursor-pointer"
                                                        style={{ color: '#DD0000' }}
                                                        onClick={() =>
                                                            handleDelete(
                                                                invoice.id
                                                            )
                                                        }
                                                    />
                                                     */}

                                                </div>

                                            </td>

                                        </tr>

                                    ))

                                ) : (

                                    <tr>

                                        <td
                                            colSpan="7"
                                            className="text-center"
                                        >
                                            No Invoice Found
                                        </td>

                                    </tr>

                                )}

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

        </Layout>
    );
};

export default InvoiceList;